import { getLocale } from "../runtime";

const sv_easteregg4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Denna sida tar lite egentid. Det behöver vi alla ibland.`
};

const easteregg4 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_easteregg4(inputs)
	return "easterEgg4";
};

export { easteregg4 as "easterEgg4" };